<template>
  <div class="animated fadeIn invoices">
    <i
      hidden
      class="ms-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <!-- newInvoiceModal -->
    <!-- <v-dialog v-model="newInvoiceModal" persistent width="500">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey">انتخاب نوع فروش</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="newInvoiceModal = false"
                ><v-icon class="close-icon">$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <div>
          <h5 class="c-grey ms-7">نوع فروش خود را انتخاب کنید:</h5>
          <v-card-text class="custom-input mb-9 mt-5">
            <v-row>
              <v-col class="text-center">
                <v-btn
                  class="green-mainBtn py-5"
                  width="150"
                  :to="'/shop/newinvoice/wholesale'"
                  >فاکتور فروش عمده</v-btn
                >
              </v-col>
              <v-col class="text-center">
                <v-btn
                  class="purple-mainBtn py-5"
                  width="150"
                  :to="'/shop/newinvoice/retail'"
                  >فاکتور فروش خرده</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </div>
      </v-card>
    </v-dialog> -->
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <!-- return-modal -->
    <v-dialog v-model="returnModal" width="600">
      <v-card class="modal-card">
        <h5 class="dark-grey-color py-5">
          <v-icon color="error">$Alert</v-icon>
          <span class="ps-2 pe-2 pt-1"
            >آیا از ابطال فاکتور {{ selected.invoiceCode }} اطمینان
            دارید؟</span
          >
        </h5>
        <div class="text-left mt-9">
          <v-btn
            class="purple-mainBtn"
            width="90"
            :loading="busy"
            @click="submit()"
            >بله</v-btn
          >
          <v-btn
            class="red-borderedBtn ms-2 ms-2 me-2"
            width="90"
            @click="returnModal = false"
            >خیر</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <!-- retun-dialog -->
    <v-dialog v-model="returnDialog" width="970">
      <v-card class="dash-modal-card">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">مرجوع کردن اقلام</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="returnDialog = false"
                ><v-icon class="close-icon">$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <div class="text-center pb-12" v-if="returnLoading">
          <cube></cube>
          <span style="font-size: 16px">در حال بارگذاری ...</span>
        </div>
        <div v-else>
          <v-card-text>
            <div class="custom-table mt-3">
              <b-table
                responsive
                show-empty
                :current-page="returnCurrentPage"
                :per-page="returnPerPage"
                :items="invoicesList"
                :fields="invoiceFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد."
                striped
                thead-class="headClass"
                tbody-class="bodyClass"
              >
                <template v-slot:empty>
                  <div
                    style="text-align: center; vertical-align: middle"
                    class="pt-0"
                  >
                    <v-icon class="red--text text--lightem-1 me-2"
                      >mdi-alert-circle-outline</v-icon
                    >
                    <span class="red--text font-weight-bold text--lightem-1"
                      >هنوز کالایی به فاکتور اضافه نشده است</span
                    >
                  </div>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:head(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{
                      data.index + 1 + returnPerPage * (returnCurrentPage - 1)
                    }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(name)="data">
                  <div
                    style="
                      text-align: center;
                      vertical-align: middle;
                      min-width: 300px;
                    "
                  >
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(price)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ Number(data.value).toLocaleString() }}
                  </div>
                </template>
                <template v-slot:cell(totalPrice)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{
                      (
                        Number(data.item.amount) * data.item.price
                      ).toLocaleString()
                    }}
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div
                    style="text-align: center; vertical-align: middle"
                    class="pt-0"
                  >
                    <v-btn
                      :disabled="data.item.status == 'مرجوع شده'"
                      @click="openReturnModal(data.item)"
                      class="purple-mainBtn"
                      width="120"
                      >مرجوع کردن</v-btn
                    >
                  </div>
                </template>
              </b-table>
              <v-row class="mt-6" v-if="invoicesList.length">
                <v-col>
                  <v-col class="d-flex flex-row">
                    <span class="c-grey pt-2">نمایش در هر صفحه</span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        attach
                        class="shop-select"
                        :menu-props="{ top: true, offsetY: true }"
                        outlined
                        v-model="returnPerPage"
                        :items="perPageOptions"
                        @change="returnCurrentPage = 1"
                      ></v-select>
                    </div>
                  </v-col>
                </v-col>
                <v-col>
                  <div>
                    <v-pagination
                      v-model="returnCurrentPage"
                      :length="Math.ceil(invoicesList.length / returnPerPage)"
                      :total-visible="5"
                      prev-icon="$ArrowLeft"
                      next-icon="$ArrowRight"
                      class="float-end"
                    ></v-pagination>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <div class="text-left py-3 ps-4 pe-4">
            <v-btn
              class="red-mainBtn white--text me-2"
              @click="returnDialog = false"
              width="100"
            >
              لغو
            </v-btn>
            <v-btn
              @click="openDeleteDialog()"
              :disabled="checkReturnedItems()"
              class="purple-mainBtn white--text"
              width="120"
            >
              مرجوع کل فاکتور
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- delete-dialog -->
    <v-dialog v-model="deleteDialog" width="600">
      <v-card class="modal-card">
        <h5 class="dark-grey-color py-5">
          <v-icon color="error">$Alert</v-icon>
          <span class="ps-2 pe-2 pt-1"
            >آیا از مرجوع کردن همه اقلام اطمینان دارید؟</span
          >
        </h5>
        <div class="text-left mt-9">
          <v-btn class="purple-mainBtn" width="90" @click="returnAll()"
            >بله</v-btn
          >
          <v-btn
            class="red-borderedBtn ms-2"
            width="90"
            @click="deleteDialog = false"
            >بازگشت</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <!-- returnOne-dialog -->
    <v-dialog v-model="returnOneDialog" width="600">
      <v-card class="modal-card">
        <h5 class="dark-grey-color py-5">
          <v-icon color="error">$Alert</v-icon>
          <span class="ps-2 pe-2 pt-1"
            >آیا از مرجوع کردن {{ returnItem.name }} اطمینان دارید؟</span
          >
        </h5>
        <div class="text-left mt-9">
          <v-btn
            class="purple-mainBtn"
            width="90"
            @click="returnProduct(returnItem)"
            >بله</v-btn
          >
          <v-btn
            class="red-borderedBtn ms-2"
            width="90"
            @click="returnOneDialog = false"
            >بازگشت</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <!-- <loading v-if="vLoading" /> -->

    <v-col lg="12" class="me-auto"></v-col>
    <v-card class="common-card">
      <div class="d-flex flex-row">
        <h4 class="c-grey pt-2 ps-2">فاکتور فروش</h4>
      </div>
      <hr class="mt-5" />
      <v-card class="text-center pb-12" v-if="isBusy">
        <cube></cube>
        <span style="font-size: 16px">در حال بارگذاری ...</span>
      </v-card>
      <v-card v-else flat>
        <v-container class="pt-12">
          <v-row>
            <v-col cols="12" md="6" class="d-flex flex-row">
              <h4 class="c-purple">فاکتور فروش فروشگاه</h4>
              <span style="padding-top: 2px" class="c-grey ms-4"
                >({{ computedInvoices.length }} فاکتور)</span
              >
            </v-col>
            <v-col class="text-left">
              <v-btn
                to="/shop/newinvoice"
                class="purple-borderedBtn"
                height="43"
                style="text-decoration: none"
              >
                <v-icon class="me-1">$Bag</v-icon>افزودن فاکتور جدید
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mt-6">
            <v-col class="c-grey d-flex flex-row flex-wrap">
              <div class="custom-input d-flex flex-row flex-wrap">
                <v-text-field
                  outlined
                  dense
                  prepend-inner-icon="$Search"
                  hide-details
                  label="جستجو در کد فاکتور..."
                  color="#4ba0e7"
                  @input="currentPage = 1"
                  v-model="codeFilter"
                  class="me-3 mt-2"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="codeFilter.length"
                      class="red--text text--lighten-2 mt-1"
                      @click="
                        codeFilter = '';
                        currentPage = 1;
                      "
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
                <v-text-field
                  outlined
                  dense
                  prepend-inner-icon="$Search"
                  hide-details
                  label="جستجو در نام مشتری..."
                  color="#4ba0e7"
                  v-model="nameFilter"
                  @input="currentPage = 1"
                  class="me-3 mt-2"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="nameFilter.length"
                      class="red--text text--lighten-2 mt-1"
                      @click="
                        nameFilter = '';
                        currentPage = 1;
                      "
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
              </div>
              <div class="customSelect2 me-3 pb-0 mt-2">
                <span class="c-blue pt-3 pe-2"> فیلتر وضعیت </span>
                <v-select
                  attach
                  class="shop-select"
                  :menu-props="{ bottom: true, offsetY: true }"
                  dense
                  outlined
                  hide-details
                  :items="types"
                  v-model="typeFilter"
                  @change="currentPage = 1"
                >
                  <template v-slot:append>
                    <v-icon class="c-blue">$ArrowDown</v-icon>
                  </template>
                </v-select>
              </div>
              <div class="customSelect2 me-3 pb-0 mt-2">
                <span class="c-blue pt-3 pe-2"> فیلتر نوع </span>
                <v-select
                  attach
                  class="shop-select"
                  :menu-props="{ bottom: true, offsetY: true }"
                  dense
                  outlined
                  hide-details
                  :items="invoiceTypes"
                  v-model="invoiceFilter"
                  @change="currentPage = 1"
                >
                  <template v-slot:append>
                    <v-icon class="c-blue">$ArrowDown</v-icon>
                  </template>
                </v-select>
              </div>
              <MyCalendar
                @submit="searchInvoices()"
                @getStartDate="getStartDate"
                @getEndDate="getEndDate"
                :label="'فیلتر زمانی'"
                :icon="'arrow'"
                :start="startDate"
                :end="endDate"
                class="mt-2"
              />
            </v-col>
          </v-row>
          <hr class="mt-5" />
          <vue-excel-xlsx
            :data="computedInvoices"
            :columns="excelFields"
            class="darkGreen-mainBtn mb-4 float-start"
            style="width: 135px; height: 35px"
            file-name="فاکتور فروش فروشگاه"
            sheet-name="فاکتور فروش فروشگاه"
            :class="computedInvoices.length ? 'white--text' : 'disabled-excel'"
          >
            <v-icon
              :class="computedInvoices.length ? 'white--text' : ''"
              class="me-1"
              >mdi-file-excel-outline</v-icon
            >
            خروجی اکسل
          </vue-excel-xlsx>
          <v-btn
            :disabled="!computedInvoices.length"
            class="darkRed-mainBtn white--text mb-4 float-end"
            style="width: 135px; height: 35px"
            @click="printReceipt()"
            depressed
            ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
          >
          <div class="custom-table mt-3">
            <b-table
              responsive
              show-empty
              :current-page="currentPage"
              :per-page="perPage"
              :items="computedInvoices"
              :fields="fields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>

              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>

              <template v-slot:cell(shopCustomerName)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    target="_blank"
                    :href="'/shop/customer/' + data.item.shopCustomerId"
                    >{{ data.value }}</a
                  >
                </div>
              </template>
              <template v-slot:cell(totalCost)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() + " ریال " }}
                </div>
              </template>

              <template v-slot:cell(type)="data">
                <div style="text-align: center; vertical-align: middle">
                  <div
                    class="mx-auto"
                    :class="
                      data.value == 'امانی'
                        ? 'purple-badge'
                        : data.value == 'قطعی'
                        ? 'green-badge'
                        : 'pink-badge'
                    "
                  >
                    {{ data.value }}
                  </div>
                </div>
              </template>

              <template v-slot:cell(operation)="row">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    v-if="!row.item._showDetails"
                    @click="row.toggleDetails"
                    class="purple-mainBtn"
                    width="120"
                    >نمایش عملیات</v-btn
                  >
                  <v-btn
                    v-else
                    @click="row.toggleDetails"
                    class="red-mainBtn"
                    width="120"
                    >بستن عملیات</v-btn
                  >
                </div>
              </template>
              <template #row-details="row">
                <div
                  class="animated fadeIn mb-2"
                  style="text-align: center; vertical-align: middle"
                >
                  <v-btn
                    class="green-mainBtn ms-1"
                    width="135"
                    height="40"
                    :to="'/shop/invoice/' + row.item.id"
                    ><v-icon class="me-1">mdi-eye</v-icon>مشاهده</v-btn
                  >
                  <v-btn
                    :loading="gettingReceipt"
                    class="purple-mainBtn ms-1"
                    width="135"
                    height="40"
                    @click="doPrint(row.item)"
                    v-if="row.item.type != 'مرجوعی'"
                    ><v-icon class="me-1">mdi-printer</v-icon>چاپ رسید</v-btn
                  >
                  <v-btn
                    class="lime-mainBtn ms-1"
                    width="135"
                    height="40"
                    :to="'/shop/editinvoice/' + row.item.id"
                    v-if="row.item.type != 'مرجوعی'"
                    ><v-icon class="me-1">mdi-pencil</v-icon>ویرایش
                    فاکتور</v-btn
                  >
                  <v-btn
                    class="new-mainBtn ms-1"
                    width="135"
                    height="40"
                    @click="openReturnDialog(row.item)"
                    v-if="
                      row.item.status != 'باطل شده' &&
                      row.item.type != 'مرجوعی'
                    "
                    ><v-icon class="me-1">mdi-restore</v-icon>مرجوع کردن</v-btn
                  >
                  <v-btn
                    v-if="
                      row.item.status != 'باطل شده' &&
                      row.item.type != 'مرجوعی'
                    "
                    class="ms-1 red-mainBtn white--text"
                    width="135"
                    height="40"
                    @click="openModal(row.item)"
                    ><v-icon class="me-1">mdi-logout-variant</v-icon>ابطال فاکتور</v-btn
                  >
                </div>
              </template>
            </b-table>
            <v-row class="mt-6" v-if="computedInvoices.length">
              <v-col>
                <v-col class="d-flex flex-row">
                  <span class="c-grey pt-2">نمایش در هر صفحه</span>
                  <div class="ms-3 me-3 number-box">
                    <v-select
                      attach
                      class="shop-select"
                      :menu-props="{ bottom: true, offsetY: true }"
                      outlined
                      v-model="perPage"
                      :items="perPageOptions"
                      @change="currentPage = 1"
                    ></v-select>
                  </div>
                </v-col>
              </v-col>
              <v-col>
                <div>
                  <v-pagination
                    v-model="currentPage"
                    :length="Math.ceil(computedInvoices.length / perPage)"
                    :total-visible="5"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    class="float-end"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-card>
    <!-- receipt -->
    <v-card>
      <div id="Receipt" v-show="false" v-if="!gettingReceipt">
        <div class="mainTable" style="width: 100%; height: 100%">
          <div style="margin-bottom: 15px">
            <div style="text-align: center; width: 100%">
              <img src="/receiptLogo2.png" height="70px" alt="" />
            </div>
          </div>
          <tbody>
            <tr>
              <td>
                <div
                  class="content"
                  style="padding: 5px 0; margin-bottom: 15px"
                >
                  <div>
                    <div>
                      <div style="text-align: center">
                        <strong style="font-size: 17px"
                          >{{ printInvoice.shopCustomerName }} عزیز، از دیدن
                          دوباره شما خوش‌حالیم!</strong
                        >
                      </div>
                      <table
                        v-if="printInvoice.shopCustomerName"
                        style="
                          border: 0px solid black !important;
                          margin-top: 15px;
                        "
                      >
                        <tr>
                          <td style="border: 0px solid black !important">
                            تاریخ خرید:
                            {{ printInvoice.date }}
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            <span style="font-size: 16px">
                              {{ printInvoice.code }}
                            </span>
                          </td>
                        </tr>
                      </table>
                      <table
                        v-if="printInvoice.status != 'ثبت شده'"
                        style="border: 0px solid black !important"
                      >
                        <tr>
                          <td style="border: 0px solid black !important"></td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            <span
                              v-if="printInvoice.status != 'ثبت شده'"
                              style="font-size: 16px; font-weight: bold"
                              >({{ printInvoice.status }})</span
                            >
                          </td>
                        </tr>
                      </table>

                      <br />
                    </div>
                  </div>
                  <b-table
                    v-if="printInvoice.details"
                    bordered
                    :fields="selectedFields"
                    :items="printInvoice.details"
                    small="small"
                    responsive
                  >
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell(name)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(amount)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value.toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(price)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(totalPrice)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{
                          (
                            Number(data.item.amount) * data.item.price
                          ).toLocaleString()
                        }}
                      </div>
                    </template>
                  </b-table>
                  <div
                    style="padding: 10px 0 0; text-align: center"
                    v-if="printInvoice.useRoyaltyCredit"
                  >
                    <span style="font-size: 13px; font-weight: bold"
                      >در این خرید از اعتبار استفاده نموده‌اید.</span
                    >
                  </div>
                  <br />
                  <table
                    class="custom-table"
                    v-if="printInvoice.details"
                    style="
                      border: 0px solid black !important;
                      padding: 0 !important;
                      width: 100%;
                      margin-bottom: 10px;
                    "
                  >
                    <tr style="margin-bottom: 15px">
                      <td style="border: 0px solid black !important">
                        جمع اقلام:
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size = 16px"
                          >{{
                            printInvoice.details
                              .map((x) => Number(x.amount))
                              .reduce((a, b) => a + b, 0)
                          }}
                        </span>
                      </td>
                    </tr>
                    <tr style="margin-bottom: 15px">
                      <td style="border: 0px solid black !important">
                        جمع کل (ریال):
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size = 16px"
                          >{{
                            printInvoice.details
                              .map((x) => Number(x.price) * Number(x.amount))
                              .reduce((a, b) => a + b, 0)
                              .toLocaleString()
                          }}
                        </span>
                      </td>
                    </tr>
                    <tr
                      v-if="
                        !printInvoice.useRoyaltyCredit && printInvoice.discount
                      "
                      style="margin-bottom: 15px"
                    >
                      <td style="border: 0px solid black !important">
                        تخفیف (ریال):
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size = 16px"
                          >{{ Number(printInvoice.discount).toLocaleString() }}
                        </span>
                      </td>
                    </tr>
                    <tr
                      v-if="printInvoice.useRoyaltyCredit"
                      style="margin-bottom: 15px"
                    >
                      <td style="border: 0px solid black !important">
                        مبلغ اعتبار (ریال):
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size = 16px"
                          >{{
                            Number(
                              printInvoice.royaltyDiscount
                            ).toLocaleString()
                          }}
                        </span>
                      </td>
                    </tr>
                  </table>

                  <div class="totalCost" style="padding: 0 10px !important">
                    <table
                      v-if="printInvoice.totalCost"
                      style="border: 0px solid black !important"
                    >
                      <tr>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: center;
                          "
                        >
                          مانده حساب مشتری از قبل (ریال):
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: center;
                          "
                        >
                          <span style="font-size = 16px"
                            >{{ newInvoice.customerBalance }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: center;
                          "
                        >
                          مبلغ قابل پرداخت (ریال):
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: center;
                          "
                        >
                          <span style="font-size = 16px"
                            >{{
                              parseInt(printInvoice.totalCost).toLocaleString()
                            }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: center;
                          "
                        >
                          مانده حساب فعلی مشتری (ریال):
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: center;
                          "
                        >
                          <span style="font-size = 16px"
                            >{{ newInvoice.newCustomerBalance }}
                          </span>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="mt-3" v-if="printInvoice.description != '-'">
                    توضیحات: {{ printInvoice.description }}
                  </div>
                  <br />
                  <!-- <div class="barcode-box">
                    <p style="text-align: center">(چاپ مجدد)</p>
                    <barcode
                      :value="printInvoice.code"
                      displayValue="false"
                      style="transform: translateX(50px)"
                    >
                    </barcode>
                  </div> -->
                  <div class="bot-box">
                    <div>اینستاگرام: pooladpeechkar.ir</div>
                    <div>شماره تماس: ۰۲۱-۵۵۴۱۵۲۷۱</div>
                    <div>شماره تماس: ۰۲۱-۵۵۴۱۵۲۸۰</div>

                    <div>ایران، تهران، خیابان قزوین، پلاک 460</div>
                    <div>&nbsp;</div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </div>
      </div>
    </v-card>
    <!-- receipt -->

    <div id="printTable" v-show="false">
      <h3 class="text-right" style="float: right">فاکتورهای فروش فروشگاه</h3>
      <b-table :items="computedInvoices" :fields="printFields">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
        <template v-slot:cell(totalCost)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ Number(data.value).toLocaleString() + " ریال " }}
          </div>
        </template>
      </b-table>
    </div>
    <br />
    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import router from "../../router";
import moment from "moment-jalaali";
// import VueBarcode from "vue-barcode";
import MyCalendar from "../../components/MyCalendar.vue";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    // barcode: VueBarcode,
    MyCalendar,
  },

  data: function () {
    return {
      type: "reprint",
      isLoaded: false,
      info: [],
      // loading: false,
      guide: false,
      types: ["همه", "ثبت شده", "باطل شده"],
      invoiceTypes: ["همه", "قطعی", "امانی", "مرجوعی"],
      moment: moment,
      gettingReceipt: false,
      startDate: moment(new Date()).subtract(7, "days").format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      fields: [
        { key: "index", label: "ردیف" },
        { key: "shopCustomerName", label: "نام مشتری" },
        { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "totalCost", label: "مبلغ" },
        { key: "type", label: "نوع" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      printFields: [
        { key: "index", label: "ردیف" },
        { key: "shopCustomerName", label: "نام مشتری" },
        { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "totalCost", label: "مبلغ" },
        { key: "type", label: "نوع" },
        { key: "status", label: "وضعیت" },
      ],
      excelFields: [
        { field: "shopCustomerName", label: "نام مشتری" },
        { field: "invoiceCode", label: "کد فاکتور" },
        { field: "date", label: "تاریخ" },
        { field: "time", label: "ساعت" },
        { field: "totalCost", label: "مبلغ (ریال)" },
        { field: "type", label: "نوع" },
        { field: "status", label: "وضعیت" },
      ],
      invoiceType: "definite",
      selectedFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل" },
        // { key: "sum", label: "موجودی" },
        // { key: "operation", label: "عملیات" },
      ],
      invoiceFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        { key: "price", label: "قیمت واحد (ریال)" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل (ریال)" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      invoicesList: [],
      TotalRows: "",
      codeFilter: "",
      nameFilter: "",
      typeFilter: "همه",
      invoiceFilter: "همه",
      returnDialog: false,
      deleteDialog: false,
      currentPage: 1,
      perPage: 10,
      returnCurrentPage: 1,
      returnPerPage: 4,
      perPageOptions: [4, 10, 20],
      T: 1,
      striped: true,
      isBusy: false,
      busy: false,
      filter: null,
      invoices: [],
      selected: "",
      newInvoice: {
        customerBalance: "",
        newCustomerBalance: "",
      },
      customer: {},
      printInvoice: {},
      returnModal: false,
      paymentType: "",
      selectedId: "",
      userId: "",
      returnedItems: "",
      returnLoading: false,
      selectedItem: "",
      itemIds: [],
      returnOneDialog: false,
      returnItem: "",
      // newInvoiceModal: false,
    };
  },

  methods: {
    // openNewInvoiceModal() {
    //   this.newInvoiceModal = true;
    // },
    doPrint(item) {
      this.getBalance(item);
    },
    getEndDate(value) {
      this.endDate = value;
    },
    openReturnModal(item) {
      this.returnOneDialog = true;
      this.returnItem = item;
    },
    returnAll() {
      this.busy = true;
      this.currentPage = 1;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/partialReturn/" + this.selectedId,
        {
          shopCustomerId: this.userId,
          shopInvoiceId: this.selected.id,
          details: this.invoicesList.filter((x) => x.status == "ثبت شده"),
          itemIds: this.itemIds,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.returnModal = false;
            this.returnDialog = false;
            this.deleteDialog = false;
            this.searchInvoices();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    submit() {
      this.busy = true;
      this.currentPage = 1;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/return",
        {
          shopInvoiceId: this.selected.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.returnModal = false;
            this.returnDialog = false;
            this.deleteDialog = false;
            this.searchInvoices();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    searchInvoices() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/invoices",
        {
          startDate: this.startDate + "00:00",
          endDate: this.endDate + "23:59",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.invoices = res.data.filter((x) => x.type != "پیش فاکتور");
            this.TotalRows = this.invoices.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          console.log(err.response);
          this.isBusy = false;
        });
    },
    computedFilterDate() {
      let date =
        "از تاریخ " +
        this.startDate.split("/")[2] +
        "/" +
        this.persianMonthName(this.startDate.split("/")[1]) +
        "/" +
        this.startDate.split("/")[0] +
        " تا تاریخ " +
        this.endDate.split("/")[2] +
        "/" +
        this.persianMonthName(this.endDate.split("/")[1]) +
        "/" +
        this.endDate.split("/")[0];

      return date;
    },
    getStartDate(value) {
      this.startDate = value;
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    openModal(item) {
      this.returnModal = true;
      this.selected = item;
    },
    openReturnDialog(item) {
      this.returnCurrentPage = 1;
      this.returnPerPage = 4;
      this.returnDialog = true;
      this.selected = item;
      this.selectedId = item.id;
      this.getReturnInfo();
    },
    getReturnInfo() {
      this.returnLoading = true;
      Axios.get(
        this.baseUrl + "/ppkpms/shop/sales/getData/" + this.selectedId,
        // {
        //   shopCustomerId: this.selected.id,
        // },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.returnLoading = false;
          if (res.status == 200) {
            this.userId = res.data.shopCustomerId;
            this.invoicesList = res.data.details;
            this.returnedItems = res.data.returnedItems
              ? res.data.returnedItems
              : [];
            this.checkReturnItems();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.returnLoading = false;
        });
    },
    checkReturnItems() {
      this.itemIds = [];
      this.invoicesList.forEach((item) => {
        if (this.returnedItems.indexOf(item.id) != -1) {
          item.status = "مرجوع شده";
        } else {
          item.status = "ثبت شده";
          this.itemIds.push(item.id);
        }
      });
      this.checkReturnedItems();
    },
    returnProduct(item) {
      this.busy = true;
      this.currentPage = 1;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/partialReturn/" + this.selectedId,
        {
          shopCustomerId: this.userId,
          details: item,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.returnOneDialog = false;
            this.searchInvoices();
            this.getReturnInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    openDeleteDialog() {
      this.deleteDialog = true;
    },
    print(item) {
      this.gettingReceipt = true;
      Axios.get(
        this.baseUrl + "/ppkpms/shop/sales/getData/" + item.id,
        // {
        //   shopInvoiceId: item.id,
        // },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
            if (this.paymentType == "قطعی") {
              this.newInvoice.newCustomerBalance =
                this.newInvoice.customerBalance;
            } else {
              this.newInvoice.newCustomerBalance =
                this.newInvoice.customerBalance + this.printInvoice.totalCost;
            }
            localStorage.setItem(
              "oldCustomerBalance",
              this.newInvoice.customerBalance
            );
            this.$router.push("/print/" + this.type + "/invoice/" + item.id);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        // .then(() => {
        //   setTimeout(() => {
        //     this.printReceipt();
        //   }, 400);
        // })
        .catch((err) => {
          console.log(err);
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><head><link rel='stylesheet' href='/receipt.css'><title>Receipt</title>"
      );
      setTimeout(() => {
        myWindow.document.write("</head><body>");
        myWindow.document.write(
          document.getElementById("printTable").innerHTML
        );
        myWindow.document.write("</body></html>");
        myWindow.document.close();
      }, 100);

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getBalance(item) {
      this.newInvoice.customerBalance = "";
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/customerBalance",
        {
          shopCustomerId: item.shopCustomerId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.newInvoice.customerBalance = res.data.balanceData;
            if (this.newInvoice.customerBalance > 0) {
              this.newInvoice.customerBalance =
                this.newInvoice.customerBalance.toLocaleString() +
                " ریال بدهکار";
            } else if (this.newInvoice.customerBalance < 0) {
              this.newInvoice.customerBalance =
                Math.abs(this.newInvoice.customerBalance).toLocaleString() +
                " ریال بستانکار";
            } else {
              this.newInvoice.customerBalance = "تسویه";
            }
            this.paymentType = item.type;
            // this.$router.push('/print/' + this.type + '/' + item.id)
            this.print(item);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    checkReturnedItems() {
      if (this.returnedItems.length == this.invoicesList.length) {
        return true;
      } else {
        return false;
      }
    },
  },
  computed: {
    totalCost() {
      return 1000;
    },
    computedInvoices() {
      let filtered;
      if (this.typeFilter == "همه") {
        filtered = this.invoices.filter(
          (x) =>
            x.shopCustomerName.includes(this.nameFilter) &&
            x.invoiceCode.toLowerCase().includes(this.codeFilter.toLowerCase())
        );
      } else {
        filtered = this.invoices.filter(
          (x) =>
            x.status == this.typeFilter &&
            x.shopCustomerName.includes(this.nameFilter) &&
            x.invoiceCode.toLowerCase().includes(this.codeFilter.toLowerCase())
        );
      }
      if (this.invoiceFilter == "همه") {
        filtered = filtered.filter(
          (x) =>
            x.shopCustomerName.includes(this.nameFilter) &&
            x.invoiceCode.toLowerCase().includes(this.codeFilter.toLowerCase())
        );
      } else {
        filtered = filtered.filter(
          (x) =>
            x.type == this.invoiceFilter &&
            x.shopCustomerName.includes(this.nameFilter) &&
            x.invoiceCode.toLowerCase().includes(this.codeFilter.toLowerCase())
        );
      }
      return filtered;
    },
  },

  mounted() {
    this.searchInvoices();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.v-select .v-input__slot fieldset {
  background-color: white !important;
}
.v-menu__content {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  margin-top: 10px;
}
.invoices {
  .custom-input {
    .v-input__slot {
      width: 210px !important;
    }
    .v-input__control {
      flex-direction: row !important;
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 45px !important;
      border-color: #4ba0e7 !important;
    }
    .v-label:not(.v-label--active) {
      transform: translateY(2px);
    }
  }
  .customSelect2 {
    padding-bottom: 10px;
    .v-input__slot {
      width: 140px !important;
    }
    .v-select__selection--comma {
      font-size: 14px !important;
    }
  }
}
.dialog-card {
  border-radius: 15px !important;
  padding: 10px;
}
</style>
<style scoped>
thead {
  background-color: white;
  color: black;
}
@media print {
  td {
    font-family: "iransans" !important;
    border-radius: 3px;
  }
  @page {
    size: A5 landscape;
    font-size: 30%;
    text-color: black;
  }

  table.mainTable {
    border: 0px !important;
  }
}
</style>
